<script setup>
import { onMounted } from 'vue'

const props = defineProps(['field', 'modelValue'])
const emit = defineEmits(['update:modelValue'])

onMounted(() => {
	if (props.modelValue === undefined && Object.prototype.hasOwnProperty.call(props.field, 'default')) {
		emit('update:modelValue', props.field.default)
	}
})
</script>

<template>
<v-autocomplete
	v-if="field.searchable"
	:model-value="modelValue"
	:label="field.label"
	:items="field.options"
	:multiple="field.multiple"
	:clearable="field.clearable"
	item-title="label"
	hide-details="auto"
	@update:model-value="(val) => emit('update:modelValue', val)"
/>
<v-select
	v-else
	:model-value="modelValue || ''"
	:label="field.label"
	:items="field.options"
	:multiple="field.multiple"
	:clearable="field.clearable"
	item-title="label"
	hide-details="auto"
	@update:model-value="(val) => emit('update:modelValue', val)"
/>
</template>

<style lang="scss" scoped>

</style>